import { useQuery } from '@tanstack/react-query';
import api from '../../api/client';
import { queryKeys } from './queryKeys';

export async function fetchBootstrap(signal) {
  const res = await api.get('/bootstrap', { signal });
  return res.data;
}

export function useBootstrapQuery({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.bootstrap(),
    queryFn: ({ signal }) => fetchBootstrap(signal),
    enabled,
  });
}
